import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend } from 'chart.js';
import SingleStatsChart from './SingleStatsChart';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend);

const StatsChart = ({ tableData, responseSummary }) => {
  if (!tableData) return null;
  const data = Array.isArray(tableData) ? tableData : [tableData];

  if (!data || data.length === 0) return null;

  return (
    <div className="tw-mt-3 tw-space-y-4">
      {data.map((stats, index) => (
        <SingleStatsChart key={stats.type} stats={stats} responseSummary={index === 0 ? responseSummary : null} />
      ))}
    </div>
  );
};

export default StatsChart;
